import React, { useState, useEffect } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import Layout from '../components/Layout/Layout';
import Input from '../components/UI/Input';
import Button from '../components/UI/Button';
import { useLanguage } from '../contexts/LanguageContext';
import { useAuth } from '../contexts/AuthContext';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiLock, FiUser } = FiIcons;

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { t } = useLanguage();
  const { login, isAuthenticated, loading: authLoading } = useAuth();

  console.log("Login component rendering. isAuthenticated:", isAuthenticated, "authLoading:", authLoading);

  // If already authenticated, redirect to admin dashboard
  if (isAuthenticated) {
    console.log("User is already authenticated, redirecting to admin");
    return <Navigate to="/admin" replace />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Clear previous errors
    setError('');
    setLoading(true);

    try {
      console.log("Login attempt with username:", username);
      if (username === 'maysalward' && password === '1234@Mrd') {
        console.log("Credentials match, attempting login");
        // Use the actual login with Supabase or mock auth
        const result = await login('admin@minecraft-education.com', '1234@Mrd');
        console.log("Login successful, result:", result);
        navigate('/admin');
      } else {
        console.log("Invalid credentials");
        setError(t('invalidCredentials'));
      }
    } catch (err) {
      console.error('Login error:', err);
      setError(t('invalidCredentials'));
    } finally {
      setLoading(false);
    }
  };

  if (authLoading) {
    return (
      <Layout title={t('adminLogin')} showLanguageToggle={true}>
        <div className="flex items-center justify-center min-h-64">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-minecraft-green mx-auto mb-4"></div>
            <p className="text-gray-600">{t('loading')}</p>
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout title={t('adminLogin')} showLanguageToggle={true}>
      <div className="max-w-md mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white rounded-lg shadow-lg p-8"
        >
          <div className="text-center mb-8">
            <div className="w-16 h-16 bg-minecraft-blue rounded-full flex items-center justify-center mx-auto mb-4">
              <SafeIcon icon={FiLock} className="w-8 h-8 text-white" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-2">
              {t('adminLogin')}
            </h2>
            <p className="text-gray-600">
              {t('loginToContinue')}
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <Input
              label={t('username')}
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder={t('enterUsername')}
              required
            />

            <Input
              type="password"
              label={t('password')}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder={t('enterPassword')}
              error={error}
              required
            />

            <Button
              type="submit"
              variant="primary"
              size="lg"
              disabled={loading}
              className="w-full"
            >
              {loading ? (
                <span>{t('loading')}</span>
              ) : (
                <>
                  <SafeIcon icon={FiUser} className="w-5 h-5" />
                  <span>{t('login')}</span>
                </>
              )}
            </Button>
          </form>
        </motion.div>
      </div>
    </Layout>
  );
};

export default Login;